import React from "react";

import { Box, Modal, ModalProps, styled } from "@mui/material";

import type { CountryNameAndCode } from "@dashboard/queries/countries";

import {
  CreateRestaurant,
  CreateRestaurantForm,
} from "./CreateRestaurantComponent";

type NewRestaurantModalProps = Omit<ModalProps, "onClose" | "children"> & {
  countries?: CountryNameAndCode[];
  onNewRestaurantCreated: () => void;
  onClose: () => void;
};

export const NewRestaurantModal = ({
  countries,
  onNewRestaurantCreated,
  onClose,
  ...rest
}: NewRestaurantModalProps) => {
  return (
    <Modal
      onClose={(_) => onClose()}
      {...rest}
      disableScrollLock
      disableEnforceFocus
    >
      <ModalBox sx={{ overflow: "scroll" }}>
        {countries ? (
          <CreateRestaurantForm
            countries={countries}
            onClose={onClose}
            onNewRestaurantCreated={onNewRestaurantCreated}
          />
        ) : (
          <CreateRestaurant
            onClose={onClose}
            onNewRestaurantCreated={onNewRestaurantCreated}
          />
        )}
      </ModalBox>
    </Modal>
  );
};

const ModalBox = styled(Box)(({ theme }) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "100%",
  maxHeight: "80%",
  bgcolor: theme.palette.grey[50],
  borderRadius: 24,
}));
